import {
  InputLabel,
  Typography,
  Box,
  Divider,
  Grid,
  Paper,
  Stack,
} from "@mui/material";
import { FormTextField } from "clients/admin/src/desktop/components/form-components/form-text-field/FormTextField";
import { useOrganization } from "clients/admin/src/desktop/contexts/OrganizationProvider";
import { useForm } from "clients/admin/src/desktop/helpers/forms/FormProvider";
import React from "react";
import type { SettingsFormValues } from "./Settings";

import "./Settings.scss";

const UpdateOrganizationInputs: React.FC = () => {
  const { setFieldValue, values } = useForm<SettingsFormValues>();

  return (
    <Stack spacing={4}>
      {/* Organization Name Section */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          border: "1px solid rgba(0, 0, 0, 0.08)",
          background: "rgba(255, 255, 255, 0.7)",
          p: 3,
          transition: "all 0.3s ease",
          "&:hover": {
            borderColor: "rgba(102, 126, 234, 0.3)",
            boxShadow: "0 8px 25px rgba(102, 126, 234, 0.1)",
          },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: "#1e293b",
            mb: 2,
            display: "flex",
            alignItems: "center",
            gap: 2,
            fontSize: "1.1rem",
          }}
        >
          <Box
            component="span"
            sx={{
              width: 12,
              height: 12,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "50%",
            }}
          />
          שם הארגון
        </Typography>
        <FormTextField
          name="name"
          id="name"
          placeholder="הכנס את שם הארגון"
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
              background: "rgba(255, 255, 255, 0.8)",
              "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#667eea",
                },
              },
              "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#667eea",
                  borderWidth: 2,
                },
              },
            },
          }}
        />
      </Paper>

      {/* Registration Process Section */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          border: "1px solid rgba(0, 0, 0, 0.08)",
          background: "rgba(255, 255, 255, 0.7)",
          p: 3,
          transition: "all 0.3s ease",
          "&:hover": {
            borderColor: "rgba(76, 175, 80, 0.3)",
            boxShadow: "0 8px 25px rgba(76, 175, 80, 0.1)",
          },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: "#1e293b",
            mb: 3,
            display: "flex",
            alignItems: "center",
            gap: 2,
            fontSize: "1.1rem",
          }}
        >
          <Box
            component="span"
            sx={{
              width: 12,
              height: 12,
              background: "linear-gradient(135deg, #4caf50 0%, #45a049 100%)",
              borderRadius: "50%",
            }}
          />
          תהליך הרשמה
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Box sx={{ mb: 3 }}>
              <InputLabel
                htmlFor="setupDescription"
                sx={{
                  fontSize: "0.95rem",
                  fontWeight: 600,
                  color: "#374151",
                  mb: 1.5,
                }}
              >
                תיאור בהרשמה
              </InputLabel>
              <FormTextField
                multiline
                minRows={5}
                limit={300}
                placeholder="תיאור שיופיע למתנדבים בתהליך ההרשמה"
                value={values.setupDescription}
                onChange={(e) => setFieldValue("setupDescription", e.target.value)}
                name="setupDescription"
                id="setupDescription"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    background: "rgba(255, 255, 255, 0.8)",
                    "&:hover": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#4caf50",
                      },
                    },
                    "&.Mui-focused": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#4caf50",
                        borderWidth: 2,
                      },
                    },
                  },
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  color: "#6b7280",
                  mt: 1,
                  display: "block",
                  fontSize: "0.8rem",
                }}
              >
                תיאור זה יוצג למתנדבים בעת ההרשמה לארגון
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Stack>
  );
};

export default UpdateOrganizationInputs;
